import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ServiceService } from 'src/app/services/service.service';

@Component({
  selector: 'app-access',
  templateUrl: './access.component.html',
  styleUrls: ['./access.component.scss']
})
export class AccessComponent implements OnInit {
  failLog = ''; fail__log_msg = false; Title;
  @Output() onChange = new EventEmitter()
    isVisible=false;
  constructor(private service:ServiceService, public dialogRef: MatDialogRef<AccessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
        console.log(data)
  }

  ngOnInit(): void {
  }
  delete() {
    let form = {};

   this.data.data.access = "No";

    
    console.log( this.data.data);
      this.service.removeAccess( this.data.data)
        .subscribe(
          (response: any) => {
            console.log(response)
            if (response.status == "success") {
            //   alert(response.message);
            this.failLog = response.message;
            this.fail__log_msg = true;
              this.dialogRef.close(response.message);
              // this.userTypeArr = response.result;
            } else {
                // alert(response.message);
              this.failLog = response.message;
              this.fail__log_msg = true;
            }
            
          })
    } 

  }

